export default function getResource(label, vars = []) {
    const resources = {
        productImage: 'Product Image for sku',
        percentageOff: `${vars[0]}% OFF`,
        percentageOffRange: `UP TO ${vars[0]}% OFF`,
        priceAriaLabel: `Original price ${vars[0]}, Sale price ${vars[1]}`
    };

    return resources[label];
}
